class BESSAppProjectsList extends BESSAppBase {

    constructor(owner) {
        super();
        this.owner = owner;
        this.contents = $('.projects-list');
        this.scrollNode = $('.project-item-more');
        this.#initContents();
    }

    #initContents() {
        this.loadingNextPage = false;
        $(window).scroll(this.#onScrolledProjects.bind(this));
        this.#onScrolledProjects();
        this.items = _.map($('.project-item'), (element) => new BESSAppProjectsItem($(element)));
        $('.app-projects-main')
            .addClassIf('projects-lt-5', this.items.length < 5)
            .addClassIf('projects-lt-10', this.items.length < 10);
    }

    reload(projectsList) {
        let newContents = projectsList;
        this.contents.animate({'opacity': 0.3}, 300, function () {
            this.contents.replaceWith(newContents);
            this.contents = $('.projects-list');
            BESSAppComponent.initialiseFor(this.contents);
            this.contents.css('opacity', 0.3);
            this.contents.animate({opacity: 1.0}, 300);
            this.#initContents();
        }.bind(this));
    }

    append(projectsList) {
        let newItemNodes = projectsList.find('.project-item');
        this.contents.append(projectsList.find('.project-item'));
        this.scrollNode.remove();
        this.contents.append(this.scrollNode);
        newItemNodes.css('opacity', 0.3);
        newItemNodes.animate({opacity: 1.0}, 300);
        BESSAppComponent.initialiseFor(this.contents);
        let newItems = _.map(newItemNodes, (element) => new BESSAppProjectsItem($(element)));
        this.items.push(...newItems);

        let hasMore = projectsList.find('.project-item-more');
        $('.project-item-more').showIf(hasMore.length > 0);
    }

    elementScrolled(elem) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = elem.offset().top;
        return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    }

    #onScrolledProjects() {
        if (this.scrollNode.length > 0 && this.elementScrolled(this.scrollNode)) {
            this.#loadNextPage();
        }
    }

    #loadNextPage() {
        this.owner.loadNextPage(this.items.length);
    }

}